<script setup lang="ts">
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

import Button from "~/components/dumb/Button.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import { ArrowLeftIcon, ArrowRightIcon, RefreshIcon } from "~/icons";
import { ButtonStyle, CommandId, IconSize } from "~/shared/enums";

defineProps<{
  isLeftbar?: boolean;
}>();

const router = useRouter();

const backEnabled = ref(!!router.options.history.state.back);
const forwardEnabled = ref(!!router.options.history.state.forward);
const backWorking = ref(false);
const forwardWorking = ref(false);
const refreshWorking = ref(false);

watch(
  () => router.currentRoute.value,
  () => {
    backEnabled.value = !!router.options.history.state.back;
    forwardEnabled.value = !!router.options.history.state.forward;
  },
  { deep: true }
);

const back = () => {
  backWorking.value = true;
  router.back();
  backWorking.value = false;
};

const forward = () => {
  forwardWorking.value = true;
  router.forward();
  forwardWorking.value = false;
};

const refresh = () => {
  refreshWorking.value = true;
  window.location.reload();
  refreshWorking.value = false;
};
</script>

<template>
  <div class="flex items-center app-drag-none">
    <Tooltip :disabled="!backEnabled" :command-id="CommandId.NAV_BACK">
      <Button
        :btn-style="ButtonStyle.SECONDARY"
        :icon="ArrowLeftIcon"
        :icon-size="IconSize.XS"
        :disabled="!backEnabled"
        :working="backWorking"
        borderless
        :is-contrast="isLeftbar"
        a11y-label="Back"
        :class="isLeftbar && backEnabled ? 'hover:bg-md' : undefined"
        @click="back" />
    </Tooltip>

    <Tooltip :disabled="!forwardEnabled" :command-id="CommandId.NAV_FORWARD">
      <Button
        :btn-style="ButtonStyle.SECONDARY"
        :icon="ArrowRightIcon"
        :icon-size="IconSize.XS"
        :disabled="!forwardEnabled"
        :working="forwardWorking"
        borderless
        :is-contrast="isLeftbar"
        a11y-label="Forward"
        :class="isLeftbar && forwardEnabled ? 'hover:bg-md' : undefined"
        @click="forward" />
    </Tooltip>

    <Tooltip :command-id="CommandId.NAV_REFRESH">
      <Button
        :btn-style="ButtonStyle.SECONDARY"
        :icon="RefreshIcon"
        :icon-size="IconSize.XS"
        :working="refreshWorking"
        borderless
        a11y-label="Refresh"
        :class="isLeftbar ? 'hover:bg-md' : undefined"
        @click="refresh" />
    </Tooltip>
  </div>
</template>
